import {
  collection, addDoc, getDocs, getDoc,
  doc, updateDoc, deleteDoc,
  query, orderBy, where, serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase';

const MUN = () => process.env.REACT_APP_MUNICIPIO_ID;
const col = (path) => collection(db, `municipios/${MUN()}/${path}`);

// ── MUNICÍPIO ──────────────────────────────────────────────────────────
export const getMunicipio = async () => {
  const snap = await getDoc(doc(db, 'municipios', MUN()));
  return snap.exists() ? snap.data() : null;
};
export const updateMunicipio = async (dados) => {
  await updateDoc(doc(db, 'municipios', MUN()), dados);
};

// ── VAF EMPRESAS ───────────────────────────────────────────────────────
export const getEmpresas = async () => {
  const q = query(col('vaf_empresas'), orderBy('perda', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};
export const addEmpresa = async (dados) =>
  addDoc(col('vaf_empresas'), { ...dados, criadoEm: serverTimestamp() });
export const deleteEmpresa = async (id) =>
  deleteDoc(doc(db, `municipios/${MUN()}/vaf_empresas`, id));

// ── VAF ALERTAS (Contestações) ─────────────────────────────────────────
export const addContestacao = async (dados) =>
  addDoc(col('vaf_alertas'), { ...dados, criadoEm: serverTimestamp(), status: 'pendente' });
export const getContestacoes = async () => {
  const snap = await getDocs(col('vaf_alertas'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ── IBS CONTRATOS ──────────────────────────────────────────────────────
export const getContratos = async () => {
  const q = query(col('ibs_contratos'), orderBy('criadoEm', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};
export const addContrato = async (dados) =>
  addDoc(col('ibs_contratos'), { ...dados, criadoEm: serverTimestamp() });
export const deleteContrato = async (id) =>
  deleteDoc(doc(db, `municipios/${MUN()}/ibs_contratos`, id));

// ── IBS PAGAMENTOS ─────────────────────────────────────────────────────
export const getPagamentos = async () => {
  const q = query(col('ibs_pagamentos'), orderBy('criadoEm', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};
export const addPagamento = async (dados) =>
  addDoc(col('ibs_pagamentos'), { ...dados, criadoEm: serverTimestamp() });

// ── USUÁRIOS ───────────────────────────────────────────────────────────
export const getUsuario = async (uid) => {
  const snap = await getDoc(doc(db, 'usuarios', uid));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};
export const getUsuarios = async () => {
  const q = query(
    collection(db, 'usuarios'),
    where('municipioId', '==', MUN())
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};
export const createUsuario = async (uid, dados) =>
  updateDoc(doc(db, 'usuarios', uid), { ...dados, municipioId: MUN(), criadoEm: serverTimestamp() });
